/* eslint-disable react/prop-types */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, valuesIn, find } from 'lodash';
import prettyPhone from '../../../lib/prettyPhone';

import {lookup} from '../../../redux/helpers/staticData';
import {COMPANY_STATUS} from '../../../common/enums';

import * as syncActions from '../../../redux/actionCreators/sync';

import Button from '../../../common/components/Button';
import JobRequestsTable from '../../../common/components/JobRequestTable';
import AssignmentTable from '../../../common/components/AssignmentTable';

@connect((state) => ({
  allowAddJobRequest: (state.contactProfile.company.companyStatus === COMPANY_STATUS.QUALIFIED_PROSPECT || state.contactProfile.company.companyStatus === COMPANY_STATUS.ACTIVE_ACCOUNT || state.contactProfile.company.companyStatus === COMPANY_STATUS.INACTIVE_ACCOUNT),
  company: state.company,
  contact: state.contactProfile,
  contacts: valuesIn(state.companyContacts),
  jobs: valuesIn(state.jobRequests),
  staticData: state.staticData,
  bqpMigrationFeature: state.staticData.featureToggles.find(feature => feature.hardcodelink === 'BQP_MIGRATION_FEATURE').value === true,
}))
export default class ClientDashboard extends React.Component {
  static propTypes = {
    allowAddJobRequest: PropTypes.object,
    company: PropTypes.object,
    contact : PropTypes.object.isRequired,
    contacts : PropTypes.array.isRequired,
    dispatch : PropTypes.func.isRequired,
    jobs: PropTypes.array.isRequired,
    staticData : PropTypes.object.isRequired,
    bqpMigrationFeature : PropTypes.bool,
  }

  constructor(props, context) {
    super(props, context);

    const initialState = {};

    this.state = initialState;
  }

  componentDidMount() {
    this.props.dispatch(syncActions.setNavState({isOpen: true, hideClose: true}));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.contact && nextProps.contact.profile) {
        if (this.firstTimeUser(nextProps)) {
          this.props.dispatch(push('/client/welcome'));
        }
    }
  }

  firstTimeUser(nextProps) {
    return (nextProps.contact.profile && !nextProps.contact.profile.verified && nextProps.contact.profile.createdBy);
  }

  render() {

    const user = this.props.contact.user;
    const profile = this.props.contact.profile;
    const company = this.props.contact.company;

    const clientAdviser = this.props.staticData.clientAdvisers && this.props.staticData.clientAdvisers.find((ca) => {
      return company.clientAdvisorId === ca.employeeId;
    });

    const contactPhoneTypes = get(this.props.staticData, 'contactPhoneTypes');
		const mainPhone = find(contactPhoneTypes, {name: 'Main'});
    const mainPhoneId = get(mainPhone, 'id');

    return (
      <div className='client-dashboard'>
        <div className='top-info-section'>
          {get(company, 'clientAdvisorId', null) && clientAdviser &&
            <div data-id='Client Advisor'>
              {
                clientAdviser &&
                <span>
                  <span>{`${clientAdviser.firstName} ${clientAdviser.lastName}`}, Client Advisor • </span>
                  <span>{clientAdviser.phoneNumber && (`${prettyPhone(clientAdviser.phoneNumber)} • `)}</span>
                  <span>{clientAdviser.email}</span>
                </span>
               }
            </div>
          }
        </div>

      <div className='grid client-dashboard-header'>
         <div className='row'>
            <div className='col'>
                <h1 data-id='Client Name'>{get(user, 'firstName')} {get(user, 'lastName')}</h1>
            </div>
           {
             !this.props.bqpMigrationFeature &&
             <div className='col buttons-container'>
               <Button
                 data-id='edit-button'
                 className='button-secondary'
                 onClick={() => this.props.dispatch(push('/client/edit'))}
                 label='Edit Info'
               />
             </div>
           }
         </div>
      </div>


        <div className='card-details'>
          <div className='center-column-1'>
            <span data-id='Title'>Title: {get(profile, 'title')}<br /></span>
            <span data-id='Phone1'>{lookup(this.props.staticData, 'contactPhoneTypes', {id: get(user, 'phoneType1')})} #: {user.phoneNumber1 && prettyPhone(get(user, 'phoneNumber1'))}{get(user, 'phoneType1') === mainPhoneId && ` Ext:  ${get(user, 'phoneExtension1')}`} <br /></span>
            <span data-id='Phone2'>{get(user, 'phoneType2') ? `${lookup(this.props.staticData, 'contactPhoneTypes', {id: get(user, 'phoneType2')})} #: ${prettyPhone(get(user, 'phoneNumber2'))}` : ''}{get(user, 'phoneType2') === mainPhoneId && ` Ext:  ${get(user, 'phoneExtension2')}`} <br /></span>
            <span data-id='Email'>Email: {get(user, 'email')}<br /></span>
          </div>
          <div className='center-column-1'>
            <span data-id='Department'>Department: {get(profile, 'department')}<br /></span>
            <span data-id='Address'>{get(user, 'address')} {get(user, 'address2')}<br /></span>
            <span data-id='City State Zip'>{get(user, 'city')}, {lookup(this.props.staticData, 'stateList', {id: get(user, 'state')}, 'abbreviation')} {get(user, 'zip')}<br /></span>
            <span data-id='Time Zone'>Time Zone: {lookup(this.props.staticData, 'timezoneList', {id: get(user, 'timezone')})}<br /></span>
          </div>
        </div>

        <div className='summary-view'>
          <h2>Summary View</h2>
          <JobRequestsTable
            columns={['IdNoLink', 'Title', 'Date', 'Status']}
            jobRequestsList={this.props.jobs}
            showFilters={false}
            showSearch={false}
            showHeader={false}
            contacts={this.props.contacts}
            linksInNewTab
            tableHeight='400px'
            companyId={this.props.company.id}
          />
          <AssignmentTable
            columns={['IdNoLink', 'Title', 'Date', 'Status']}
            assignmentList={[]}
            showFilters={false}
            showSearch={false}
            showHeader={false}
          />
        </div>
        {
          this.props.allowAddJobRequest &&
          !this.props.bqpMigrationFeature &&
          <div className='add-job-button' data-id='Add Job Request'>
            <Button
              data-id='add-button'
              className='button-main-large'
              onClick={() => this.props.dispatch(push('/client/jobrequest'))}
              label='Add Job Request'/>
          </div>
        }
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/client/ClientDashboard/index.js